import { SETTINGS_MENU_ITEMS_RAW } from "./navConfig";

/**
 * Nav keys always visible when tenant app-scoping is on: Settings group (all master-data
 * links under Settings in nav) + home + All modules launcher.
 */
const EXEMPT_KEYS = new Set([
  "apps-hub",
  "dashboard",
  "profile",
  "notifications",
  "activity-log",
  "messaging",
  "KAIZEN",
  "MACHINE_HEALTH",
  "OEE_PRODUCTION",
  "SPARE_INVENTORY",
  "RCA_5WHY",
  "CAPA",
  "SAFETY_OBS",
  "HAZARD",
  "INCIDENT",
  "WORK_ORDER",
  "FLOWCHART",
  "WORK_PERMIT",
  "BI_DASHBOARD",
  "REPORTS",
  "OPL",
  "QUALITY_5S",
  ...SETTINGS_MENU_ITEMS_RAW.map(i => String(i.key).toUpperCase()).filter(Boolean)
]);

export function isNavKeyExemptFromAppScope(key) {
  if (!key) return true;
  const k = String(key).toUpperCase();
  if (k.startsWith('ADMIN-')) return true;
  return EXEMPT_KEYS.has(k);
}
